module.exports = __webpack_public_path__ + "index.html"


/*****************
 ** WEBPACK FOOTER
 ** ./src/index.html
 ** module id = 606
 ** module chunks = 0
 **/